import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import { Box, Paper, IconButton, Chip, TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CustomizedDialogs from "../MuiReusableComponents/MuiPopupDialog/pop-up-withoutAppBar";
import MyButton from "../MuiReusableComponents/MuiButton/buttonMUI";
import {
    startDeleteLeave,
    startSingleLeaveData,
    startAllMyLeavesData,
    myLeaveDataCountSelector
} from "../../store1/leaves data/leavesData.Slice.Selector";
import { readStringDate } from "../../function utils/functionUtils";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { PERMISSIONS } from "routes/permissionsCode";
import { hasPermission } from "store1/user login data/user.login.data.slice.slector";

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    if (!array || !Array.isArray(array)) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, headCells } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow size="small">
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        size="small"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                        align="left"
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const DeleteButton = ({ handleClickOpen, formDefaultData }) => {
    const canCancelLeave = useSelector((state) => hasPermission(state, PERMISSIONS.HR.LEAVE.CANCEL));
    return (
        <IconButton
            disabled={!canCancelLeave}
            title="Delete"
            aria-label="delete"
            onClick={() => {
                handleClickOpen();
            }}
        >
            <DeleteIcon color="error" />
        </IconButton>
    );
};

const ConfirmMessage = ({ formDefaultData, setPopUpBool }) => {
    const { row } = formDefaultData;

    const dispacth = useDispatch();
    return (
        <>
            <Box sx={{ padding: "10px 5px" }}>
                <Typography>Do you want to delete this record ?</Typography>
            </Box>
            <Box sx={{ p: "10px 0 0 0" }}>
                <MyButton
                    size="small"
                    onClick={() => {
                        dispacth(startDeleteLeave(row.id));
                        setPopUpBool(false);
                    }}
                    variant="contained"
                >
                    Yes{""}
                </MyButton>
                <MyButton
                    size="small"
                    sx={{ marginLeft: "20px" }}
                    onClick={() => {
                        setPopUpBool(false);
                    }}
                >
                    No
                </MyButton>
            </Box>
        </>
    );
};

export default function MyLeavesTable({ headCells, rows }) {
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("employeeId");
    const dispatch = useDispatch();
    const [pageIndex, setPageIndex] = React.useState(1);
    const totalRows = useSelector(myLeaveDataCountSelector);
    const navigate = useNavigate();
    const locationName = "/dashboard/my-leaves";

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handlePageChange = (event, newPage) => {
        setPageIndex(newPage + 1);

        dispatch(startAllMyLeavesData({
            pageSize: 10,
            pageIndex: newPage + 1,
            start_date: "",
            end_date: "",
            approval_status: "-1"
        }));
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Paper sx={{ mb: 2, padding: "10px", width: "100%" }}>
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size="medium"
                    >
                        <EnhancedTableHead
                            headCells={headCells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                ?.map((row, idx) => {
                                    const serialNumber = idx + 1;
                                    return (
                                        <TableRow hover key={idx}>
                                            {headCells.map((head, idxHead) => {
                                                if (head.id === "id") {
                                                    return (
                                                        <TableCell
                                                            key={`${idx}${idxHead}`}
                                                            size="small"
                                                            align="left"
                                                            sx={{ width: '50px' }}
                                                        >
                                                            {serialNumber}
                                                        </TableCell>
                                                    );
                                                }
                                                if (head.id === "to_date" || head.id === "from_date") {
                                                    return (
                                                        <TableCell
                                                            key={`${idx}${idxHead}`}
                                                            size="small"
                                                            align="left"
                                                        >
                                                            {`${readStringDate(row[head.id])}`}
                                                        </TableCell>
                                                    );
                                                }
                                                if (head.id === "action") {
                                                    return (
                                                        <TableCell
                                                            size="small"
                                                            key={`${idx}${idxHead}`}
                                                            sx={{ width: "100px" }}
                                                        >
                                                            <Box sx={{ display: "flex" }}>
                                                                <IconButton
                                                                    title="View more details"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        dispatch(startSingleLeaveData(row.id));
                                                                        navigate(`${locationName}/${row.id}/view-leave`);
                                                                    }}
                                                                >
                                                                    <VisibilityIcon color="primary" />
                                                                </IconButton>

                                                                {row.approval_status == 0 && (
                                                                    <IconButton
                                                                        title="Edit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            dispatch(startSingleLeaveData(row.id));
                                                                            navigate(`${locationName}/${row.id}/edit`);
                                                                        }}
                                                                    >
                                                                        <Edit color="primary" />
                                                                    </IconButton>
                                                                )}

                                                                {row.approval_status == 0 && (
                                                                    <CustomizedDialogs
                                                                        maxWidth="xs"
                                                                        DialogContentForm={ConfirmMessage}
                                                                        topic={"Confirm"}
                                                                        ButtonForFormDialog={DeleteButton}
                                                                        formDefaultData={{ row }}
                                                                    />
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    );
                                                }
                                                if (head.id === "approval_status") {
                                                    return (
                                                        <TableCell
                                                            key={`${idx}${idxHead}`}
                                                            size="small"
                                                            align="left"
                                                        >
                                                            <Chip
                                                                variant="outlined"
                                                                label={row.approval_status == 0 ? "Pending" : row.approval_status == 1 ? 'Approved' : "Rejected"}
                                                                color={row.approval_status == 0 ? "secondary" : row.approval_status == 1 ? 'success' : "error"}
                                                            />
                                                        </TableCell>
                                                    );
                                                }
                                                return (
                                                    <TableCell
                                                        size="small"
                                                        key={`${idx}${idxHead}`}
                                                        align="left"
                                                    >
                                                        {row[head.id]}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                    {rows && rows.length > 0 && totalRows > 0 && (
                        <TablePagination
                            component="div"
                            count={totalRows}
                            rowsPerPage={10}
                            page={pageIndex - 1}
                            onPageChange={handlePageChange}
                        />
                    )}

                </TableContainer>
                {rows && rows.length === 0 ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
                        <Typography variant="h5">
                            No Leaves Found
                        </Typography>
                    </Box>
                ) : null}
            </Paper>
        </Box>
    );
}